import { history } from './../store/history.js';

class PushStateAnchorHistory extends HTMLAnchorElement {
	static get observedAttributes() {
		return ['state', 'title', 'href', 'refresh'];
	}

	connectedCallback() {
		this.state = this.getAttribute('state');
		this.title = this.getAttribute('title') || '';
		this.href = this.getAttribute('href');
		this.refresh = this.getAttribute('refresh');
		this.addEventListener('click', this.onClick);
	}

	attributeChangedCallback(name, oldVal, newVal) {
		if (this[name] !== newVal) {
			this[name] = newVal;
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.onClick);
	}

	onClick(event) {
		const invalidLink = !this.href;
		const refresh = !!JSON.parse(this.refresh);
		const externalLink = this.href.startsWith('http') && window.location.host !== new URL(this.href).host;
		const openNewTab = event.ctrlKey || event.metaKey || event.which === 2;
		if (invalidLink || externalLink || openNewTab || refresh) {
			return;
		}

		// push state into the history stack
		history.push(this.href, JSON.parse(this.state) || { from: history.location });
		event.preventDefault();
	}

	get state() {
		return this._state;
	}

	get title() {
		return this._title;
	}

	get href() {
		return this._href;
	}

	get refresh() {
		return this._refresh;
	}

	set state(value) {
		this._state = value;
		this.setAttribute('state', value);
	}

	set title(value) {
		this._title = value;
		this.setAttribute('title', value);
	}

	set href(value) {
		this._href = value;
		this.setAttribute('href', value);
	}

	set refresh(value) {
		this._refresh = value;
		this.setAttribute('refresh', value);
	}
}

customElements.define('pushstate-anchor', PushStateAnchorHistory, { extends: 'a' });



// WEBPACK FOOTER //
// ./mobile-core/src/components/pushstate-anchor-history.js